import { useState, useCallback } from 'react';
import { modalForbidden } from "../components/DefaultAjax";
import { toastFunction } from '../components/mainFunctions';
import i18n from "i18n-react";
import SecureAjax from '../utils/SecureAjax';

export const useStorage = ({ url, setSpinner, setModalContent }) => {
    const [storageUsed, setStorageUsed] = useState(0);
    const [totalStorage, setTotalStorage] = useState(0);
    const [percentageUsedStorage, setPercentageUsedStorage] = useState(0);
    const [classPercentageStorage, setClassPercentageStorage] = useState("");
    const [extraStorageList, setExtraStorageList] = useState([]);
    const [currentExtraStorageId, setCurrentExtraStorageId] = useState(0);
    const [currentExtraStorageSize, setCurrentExtraStorageSize] = useState("");
    const [selectedPlanId, setSelectedPlanId] = useState("");

    const getStorageSize = useCallback(() => {
        SecureAjax.get("extraStoragePack/getStorageData")
            .then((res) => {
                if (res) {
                    let result = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    if (result.storageUsed !== undefined) {
                        const used = parseFloat(result.storageUsed);
                        const total = parseFloat(result.totalStorage);

                        setStorageUsed(used);
                        setTotalStorage(total);
                        const percentage = total > 0 ? (used * 100) / total : 0;
                        const fixedPercentage = parseFloat(percentage.toFixed(2));

                        setPercentageUsedStorage(fixedPercentage);


                        if (fixedPercentage >= 75) {
                            setClassPercentageStorage("danger");
                        } else if (fixedPercentage >= 50) {
                            setClassPercentageStorage("warning");
                        } else {

                            setClassPercentageStorage("success");
                        }
                    }
                }
            }).catch((error) => {
                setSpinner("");
                if (error.response && error.response.status === 403) {
                    setTimeout(() => {
                        setModalContent(modalForbidden());
                    }, 10);
                }
            });
    }, [setSpinner, setModalContent]);

    const updateStorageDetails = (res2, list) => {

        if (!res2?.data) return;

        const data = res2.data;
        const isValidData = data !== "" && data > 0 && data !== "0";

        if (isValidData) {
            const currentId = parseInt(data);
            setCurrentExtraStorageId(currentId);

            const matchingStorage = list.find(eL => eL.id === currentId);
            if (matchingStorage) {
                setCurrentExtraStorageSize(matchingStorage.storageSize);
            }
        }
    };


    const manageStorage = useCallback(() => {
        SecureAjax.get("extraStoragePack/extraStoragePacks?isFromSupport=false")
            .then((res) => {
                if (!res) return null;

                const list = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                setExtraStorageList(list);

                return SecureAjax.get("extraStoragePack/getServiceExtraStoragePackId")
                    .then((res2) => ({ res2, list }));
            })
            .then((data) => {
                if (!data) return;


                updateStorageDetails(data.res2, data.list);
                setSpinner("");
            })
            .catch((error) => {
                setSpinner("");
                if (error.response && error.response.status === 403) {
                    setTimeout(() => {
                        setModalContent(modalForbidden());
                    }, 10);
                }
            });
    }, [url, setSpinner, setModalContent]);

    const confirmNewExtraStorage = useCallback(() => {
        setSpinner(true);

        SecureAjax.post("extraStoragePack/addDetailTemp?extraStoragePackId=" + selectedPlanId)
            .then((res) => {
                if (res) {
                    let result = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    if (result === "0" || result === 0) {
                        setModalContent("");
                        setSelectedPlanId("");
                        toastFunction(i18n.translate("plan_activated"), "success");

                        const token = localStorage.getItem('auth_token') || "";

                        const platformUrl = document.querySelector("#platformUrl")?.value || "";
                        const pathRoot = document.querySelector("#pathRoot")?.value || "";

                        window.location.href = `${platformUrl}${pathRoot}login/receiptTokenFromAppWeb?tokenOfUser=${token}&urlToRedirect=/html/dashboardMain.html?lang=es?module=payExtraStorageFromAppWeb`;
                    } else {
                        toastFunction(i18n.translate("an_error_has_ocurred"), "error");
                    }
                }
            }).catch((error) => {
                setSpinner("");
                if (error.response && error.response.status === 403) {
                    setTimeout(() => {
                        setModalContent(modalForbidden());
                    }, 10);
                }
            });
    }, [selectedPlanId, setModalContent, setSpinner]);

    const confirmSuspendExtraStorage = useCallback((onSuccess) => {
        SecureAjax.get("extraStoragePack/removeDetail?serviceExtraStoragePackId=" + currentExtraStorageId)
            .then((res) => {
                if (res) {
                    let result = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    if (result === 0 || result === "0") {
                        setModalContent("");
                        setCurrentExtraStorageId(0);
                        setSelectedPlanId("");
                        toastFunction(i18n.translate("plan_deactivated"), "success");
                        if (onSuccess) onSuccess();
                    } else {
                        toastFunction(i18n.translate("an_error_has_ocurred"), "error");
                    }
                }
            }).catch((error) => {
                setSpinner("");
                if (error.response && error.response.status === 403) {
                    setTimeout(() => {
                        setModalContent(modalForbidden());
                    }, 10);
                }
            });
    }, [url, currentExtraStorageId, setModalContent, setSpinner]);

    return {
        storageUsed, totalStorage, percentageUsedStorage, classPercentageStorage,
        extraStorageList, currentExtraStorageId, currentExtraStorageSize,
        selectedPlanId, setSelectedPlanId,
        getStorageSize, manageStorage, confirmNewExtraStorage, confirmSuspendExtraStorage
    };
};